module.exports = __webpack_public_path__ + "img/color-w-2.195a0f0.webp";